import axios from 'axios';

// El backend de KC manda errores en varias formas:
//   { error: { code, message } }   ← formato canónico
//   { code, message }              ← top-level
//   { error: 'string' }            ← error como string
// Estos helpers normalizan el acceso defensivamente.

export function extractApiErrorCode(error) {
  if (!axios.isAxiosError(error)) return null;
  const data = error.response && error.response.data;
  if (typeof data === 'string') return data;
  if (data && typeof data === 'object') {
    const nested = data.error && typeof data.error === 'object' ? data.error : null;
    const candidate =
      (nested && nested.code) ||
      data.code ||
      (typeof data.error === 'string' ? data.error : null) ||
      data.message;
    if (typeof candidate === 'string') return candidate;
  }
  return null;
}

export function extractApiErrorMessage(error) {
  if (!axios.isAxiosError(error)) return null;
  const data = error.response && error.response.data;
  if (typeof data === 'string') return data;
  if (data && typeof data === 'object') {
    const nested = data.error && typeof data.error === 'object' ? data.error : null;
    const candidate = (nested && nested.message) || data.message;
    if (typeof candidate === 'string') return candidate;
  }
  return null;
}
